export enum RouteName {
    index = '/',
    about = '/about',
    date = '/date',
    bffUS = '/bff-us',
    localisedIndex = '/[lang]',
    localisedAbout = '/[lang]/about',
    localisedDate = '/[lang]/date',
    localisedBffUS = '/[lang]/bff-us',
}
